import {
  Stepper,
  StepperProvider,
  useStepper,
} from '@/components/Molecules/Stepper'
import { buildPath } from '@/routes'
import { PropsWithChildren } from 'react'

export const Steps = {
  Charges: {
    id: 0,
    path: buildPath('/payments/process'),
    title: 'Select Charges',
    description: 'Choose outstanding charges to pay',
  },
  Amounts: {
    id: 1,
    path: buildPath('/payments/process/amounts'),
    title: 'Payment Amounts',
    description: 'Specify amounts for each charge',
  },
  Confirm: {
    id: 2,
    path: buildPath('/payments/process/confirm'),
    title: 'Review & Submit',
    description: 'Review, pay, and submit your payment',
  },
} as const

const orderedSteps = Object.values(Steps).sort((a, b) => a.id - b.id)

export function PaymentProcessSteps({ children }: PropsWithChildren) {
  return (
    <StepperProvider steps={orderedSteps}>
      <Stepper
        allComplete={buildPath('/payments/process/success')}
        canJumpBack
      />
      {children}
    </StepperProvider>
  )
}

export const usePaymentProcessStepper = () => useStepper<typeof orderedSteps>()
